import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import * as colors from '~/constants/colors'

export default makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        item: {
            marginBottom: theme.spacing(2),
        },
        title: {
            marginBottom: theme.spacing(4),
        },
        subtitle: {
            color: colors.GREY_COLOR.Grey1,
        },
        actions: {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: theme.spacing(4),
        },
    })
)
